enum OnboardingKeys {
  ONBOARDING = "onboarding",
}

export default OnboardingKeys;
